import React from "react";

const Message = () => {
  return <div>Message Page</div>;
};

export default Message;
